import { CatalogPage, type CatalogFilter } from './pages/CatalogPage';
import { HelpPage } from './pages/HelpPage';
import { HomePage } from './pages/HomePage';
import { PracticePage } from './pages/PracticePage';
import { SettingsPage } from './pages/SettingsPage';
import { SetupPage } from './pages/SetupPage';
import { href, useRoute } from './router';

const NAV: { key: string; label: string }[] = [
  { key: '', label: 'Accueil' },
  { key: 'configurer', label: 'Mon piano' },
  { key: 'catalogue', label: 'Catalogue' },
  { key: 'reglages', label: 'Réglages' },
  { key: 'aide', label: 'Aide' },
];

/** Version affichée en pied de page et dans dist/version.json (définie par Vite depuis package.json). */
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev';

export function App() {
  const route = useRoute();
  const [head = '', ...rest] = route.segments;
  const isPractice = head === 'pratique';
  let page: JSX.Element;
  switch (head) {
    case '':
      page = <HomePage />;
      break;
    case 'configurer':
      page = <SetupPage />;
      break;
    case 'catalogue':
      page = <CatalogPage filter={rest[0] === 'exercices' || rest[0] === 'morceaux' ? (rest[0] as CatalogFilter) : 'tout'} />;
      break;
    case 'pratique':
      // Drapeaux après l'identifiant : « notes » (notes descendantes garanties), « tempo » (mode), « md » / « mg » (main).
      page = <PracticePage scoreId={rest[0] ?? ''} flags={rest.slice(1)} />;
      break;
    case 'reglages':
      page = <SettingsPage />;
      break;
    case 'aide':
      page = <HelpPage />;
      break;
    default:
      page = (
        <main className="page">
          <p>Page introuvable.</p>
          <a className="btn" href={href()}>
            Accueil
          </a>
        </main>
      );
  }
  return (
    <div className={isPractice ? 'app practice-mode' : 'app'}>
      {!isPractice && (
        <header className="topbar">
          <a className="brand" href={href()}>
            <span className="brand-mark" aria-hidden="true" />
            pianoHome
          </a>
          <nav aria-label="Navigation principale">
            {NAV.map((n) => (
              <a key={n.key} href={href(n.key)} className={head === n.key ? 'on' : ''}>
                {n.label}
              </a>
            ))}
          </nav>
        </header>
      )}
      {page}
      {!isPractice && <footer className="foot">pianoHome, version {APP_VERSION}. L’audio est analysé sur votre appareil et n’est jamais envoyé.</footer>}
    </div>
  );
}
